import { Component, OnInit, NgZone } from "@angular/core";
import { Observable } from "rxjs";
import { MatChipSelectionChange } from "@angular/material/chips";
import { AngularFirestore } from "@angular/fire/firestore/";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { OrderDialogComponent } from "../order-dialog/order-dialog.component";
import { LoadingDialogComponent } from "../loading-dialog/loading-dialog.component";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFireFunctions } from "@angular/fire/functions";
import { SubjectsChooserDialogComponent } from "../subjects-chooser-dialog/subjects-chooser-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";
import { NewPasswordDialogComponent } from "../new-password-dialog/new-password-dialog.component";

@Component({
  selector: "app-calculator",
  templateUrl: "./calculator.component.html",
  styleUrls: ["./calculator.component.scss"],
})
export class CalculatorComponent implements OnInit {
  title = "priceCalculator";
  totalPrice = 0;
  totalPriceWithDiscount = 0;
  selectedSubjects = [];
  selectedStudyboxes = [];
  numOfMonths = 1;
  monthlyFee = 0;
  selectedChip = 1;
  isOwnedUpgradeActive = false;
  p = 0.035;
  socialInfoLeft = [
    {
      href: "https://www.instagram.com/binarybioskop/",
      name: "@binarybioskop",
      icon: "../assets/images/igLogo.png",
    },
    {
      href: "https://www.facebook.com/binarybioskop1011/",
      name: "/binarybioskop1011",
      icon: "../assets/images/fbLogo.png",
    },
  ];
  socialInfoRight = [
    {
      name: "066 00 11 00",
      icon: "../assets/images/phone.png",
    },
    {
      name: "Vojvode Stepe 206, Beograd",
      icon: "../assets/images/map.png",
    },
    {
      name: "binarybioskop@gmail.com",
      icon: "../assets/images/mail.png",
    },
  ];

  subjectsJIT: any[] = [];
  subjectsJIT_selected: any[] = [];
  subjectsREG: any[] = [];
  subjectsREG_selected: any[] = [];
  chipSelectionChanges: Observable<MatChipSelectionChange> = new Observable();
  items: Observable<any[]>;
  user: any;
  constructor(
    private auth: AngularFireAuth,
    private zone: NgZone,
    private firestore: AngularFirestore,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private func: AngularFireFunctions,
    private route: ActivatedRoute,
    private router:Router
  ) {
    func
      .httpsCallable("addUserOwnedStudyboxes")({
        indeks: "201506144",
      })
      .subscribe(() => { });
    console.log("Budimo kolegijalni! :)");
    this.chipSelectionChanges.subscribe(() => { });
    this.auth.onAuthStateChanged((user) => {
      this.user = user;
      this.getSubjectsWithStudyboxes();
    });
  }
  getSubjectsWithStudyboxes() {
    this.firestore
      .collection("subjects", (ref) => ref.where("group", "==", "FON"))
      .get()
      .subscribe((subjects) => {
        let allStudyboxes = [];
        this.getAllStudyboxes()
          .then((as: any[]) => {
            allStudyboxes = as;
          })
          .then(() => {
            var _subjects = subjects.docs
              .map((sub) => {
                let s = sub.data();
                s.id = sub.id;
                s.selectedStudyboxes = [];
                return s;
              })
              .filter((s) => !s.hideInCalculator);
            console.log(_subjects);
            this.subjectsJIT = _subjects.map((sub) => {
              let s = JSON.parse(JSON.stringify(sub));
              s.JIT = true;
              s.array = 1;
              s.price = sub.priceJIT;
              return s;
            });
            this.subjectsJIT = this.groupSubjectsByYear(this.subjectsJIT);
            for (let sub of _subjects) {
              let s = JSON.parse(JSON.stringify(sub));
              s.REG = true;
              s.studyboxes = allStudyboxes.filter((sb) => sb.subjectId == s.id);
              s.studyboxesShown = allStudyboxes.filter(
                (sb) =>
                  sb.subjectId == s.id &&
                  sb.studyboxName != "Ceo ispit (kompletna priprema)"
              );
              if (
                s.studyboxes.filter(
                  (sb) => sb.studyboxName == "Ceo ispit (kompletna priprema)"
                )[0] != undefined
              )
                s.price = s.studyboxes.filter(
                  (sb) => sb.studyboxName == "Ceo ispit (kompletna priprema)"
                )[0].studyboxPrice;
              else s.price = s.priceREG;
              console.log(s.price);
              this.subjectsREG.push(s);
            }
            if (this.user) {
              this.getUserOwnedSubjects().then((userOwnedSubjects) => {
                this.subjectsREG.forEach((s) => {
                  const userOwnedSubject = userOwnedSubjects.filter(
                    (sub) => sub.id == s.id
                  )[0];
                  if (userOwnedSubject) {
                    if (
                      userOwnedSubject.selectedStudyboxes[0].studyboxName ==
                      "Ceo ispit (kompletna priprema)"
                    ) {
                      s.bigStudyboxChecked = true;
                      s.bigStudyboxDisabled = true;
                      s.studyboxesShown.forEach((sb) => {
                        sb.checked = true;
                        sb.disabled = true;
                      });
                    } else {
                      s.bigStudyboxDisabled = true;
                      s.studyboxesShown.forEach((sb) => {
                        const userOwnedStudybox =
                          userOwnedSubject.selectedStudyboxes.filter(
                            (usb) => usb.id == sb.id
                          )[0];
                        if (userOwnedStudybox) {
                          sb.checked = true;
                          sb.disabled = true;
                          sb.isUserOwned = true;
                        }
                      });
                    }
                  }
                });
                this.subjectsREG = this.groupSubjectsByYear(this.subjectsREG);
              });
            } else {
              this.subjectsREG = this.groupSubjectsByYear(this.subjectsREG);
            }
          });
      });
  }
  ngOnInit(): void {

    var mode = this.route.snapshot.queryParamMap.get('mode');
    var oobCode = this.route.snapshot.queryParamMap.get('oobCode');
    var customToken = this.route.snapshot.queryParamMap.get('customToken');
    if (oobCode != null && mode === "resetPassword") {
      this.auth.verifyPasswordResetCode(oobCode)
        .then((email) => {
          var dialogRef = this.dialog.open(NewPasswordDialogComponent, {
            data: {
              oobCode: oobCode,
              email: email
            }
          })
          dialogRef.afterClosed()
            .subscribe((statusCode) => {
              if (statusCode === 200) this.openSnackBar("Lozinka promenjena", "OK");
              else if (statusCode === 400) this.openSnackBar("Lozinka nije promenjena", "OK");
            })
        })
        .catch((err) => {
          console.log(err);
          this.openSnackBar("Zahtev istekao ili nije validan!", "OK");
        })
    }
    this.auth.onAuthStateChanged(async (userInfo) => {
      if (!userInfo) {
        if (oobCode == null && customToken == null) {
          // window.location.href = '/aplikacija/'
          this.router.navigateByUrl('/kalkulator')
        }
        if (customToken != null) {
          this.auth.signInWithCustomToken(customToken)
        }
      }
    })
  }
  bigStudyboxChange(subject, panelUI) {
    console.log(subject.studyboxesShown.filter((sb) => !sb.checked).length);
    if (subject.studyboxesShown.length != 0) {
      if (subject.studyboxesShown.filter((sb) => !sb.checked).length == 0) {
        subject.studyboxesShown.forEach((sb) => (sb.checked = false));
        subject.selectedStudyboxes = [];
        this.selectedSubjects.splice(this.selectedSubjects.indexOf(subject), 1);
      } else {
        subject.studyboxesShown.forEach((sb) => (sb.checked = true));
        subject.selectedStudyboxes = subject.studyboxes.filter(
          (sb) => sb.studyboxName == "Ceo ispit (kompletna priprema)"
        );
        this.selectedSubjects.push(subject);
      }
    } else {
      subject.bigStudyboxChecked = !subject.bigStudyboxChecked;
      if (subject.bigStudyboxChecked) {
        subject.selectedStudyboxes = subject.studyboxes.filter(
          (sb) => sb.studyboxName == "Ceo ispit (kompletna priprema)"
        );
        this.selectedSubjects.push(subject);
      } else {
        this.selectedSubjects.splice(this.selectedSubjects.indexOf(subject), 1);
        subject.selectedStudyboxes = [];
      }
    }
    this.calculateTotal();
    if (!subject.expanded) {
      subject.expanded = true;
      panelUI._toggle();
    }
  }
  getAllStudyboxes() {
    return new Promise((resolve, reject) => {
      let allStudyboxes = [];
      this.firestore
        .collection(`studyboxes`)
        .get()
        .subscribe((studyboxes) => {
          allStudyboxes = studyboxes.docs.map((sb) => {
            let studybox = sb.data();
            studybox.id = sb.id;
            return studybox;
          });
          resolve(allStudyboxes);
        });
    });
  }
  getUserOwnedSubjects(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.firestore
        .collection(`users/${this.user.uid}/subjects`)
        .get()
        .subscribe((subjectsSnap) => {
          let subjects = subjectsSnap.docs.map((subjectSnap) => {
            let subject = subjectSnap.data();
            subject.id = subjectSnap.id;
            return subject;
          });
          resolve(subjects);
        });
    });
  }
  studyboxSelectionChange(event, subject) {
    let studybox = event.option.value;
    subject.studyboxesShown[subject.studyboxesShown.indexOf(studybox)].checked =
      event.option.selected;
    console.log(event);
    if (
      this.user &&
      subject.studyboxesShown.filter((sb) => sb.isUserOwned).length != 0
    ) {
      if (event.option.selected) subject.selectedStudyboxes.push(studybox);
      else
        subject.selectedStudyboxes.splice(
          subject.selectedStudyboxes.indexOf(studybox),
          1
        );
    } else if (
      subject.studyboxesShown.filter((sb) => !sb.checked).length == 0
    ) {
      console.log("ALL CHECKED");
      subject.bigStudyboxChecked = true;
      subject.selectedStudyboxes = subject.studyboxes.filter(
        (sb) => sb.studyboxName == "Ceo ispit (kompletna priprema)"
      );
    } else {
      console.log("NOT ALL CHECKED");
      subject.bigStudyboxChecked = false;
      if (event.option.selected) subject.selectedStudyboxes.push(studybox);
      else
        subject.selectedStudyboxes.splice(
          subject.selectedStudyboxes.indexOf(studybox),
          1
        );
      subject.selectedStudyboxes = subject.studyboxesShown.filter(
        (sb) => sb.checked
      );
    }
    this.calculateTotal();
  }
  selectionChange(event, array) {
    if (event.option.value.selected) event.option.value.selected = false;
    else event.option.value.selected = true;
    if (!event.option.selected)
      this.selectedSubjects.splice(
        this.selectedSubjects.indexOf(event.option.value),
        1
      );
    else this.selectedSubjects.push(event.option.value);
    this.enableOption(event.option.value);
    if (array === "jit")
      this.subjectsJIT_selected = event.source.selectedOptions.selected.map(
        (v) => v.value
      );
    else
      this.subjectsREG_selected = event.source.selectedOptions.selected.map(
        (v) => v.value
      );

    // this.selectedSubjects = this.subjectsJIT_selected.concat(this.subjectsREG_selected);
    this.calculateTotal();
  }
  disableOption(subject) {
    if (subject.array == 1) {
      var i = this.subjectsREG[subject.year - 1].indexOf(subject);
      this.subjectsJIT[subject.year - 1][i].selected = true;
    } else {
      var i = this.subjectsJIT[subject.year - 1].indexOf(subject);
      this.subjectsREG[subject.year - 1][i].selected = true;
    }
  }
  enableOption(subject) {
    console.log(subject);
    if (subject.REG) {
      var i = this.subjectsREG[subject.year - 1].indexOf(subject);
      if (this.subjectsJIT[subject.year - 1][i].selected)
        this.selectedSubjects.splice(
          this.selectedSubjects.indexOf(this.subjectsJIT[subject.year - 1][i]),
          1
        );
      this.subjectsJIT[subject.year - 1][i].selected = false;
    } else {
      var i = this.subjectsJIT[subject.year - 1].indexOf(subject);
      if (this.subjectsREG[subject.year - 1][i].selected)
        this.selectedSubjects.splice(
          this.selectedSubjects.indexOf(this.subjectsREG[subject.year - 1][i]),
          1
        );
      this.subjectsREG[subject.year - 1][i].selected = false;
    }
  }
  groupSubjectsByYear(subjects) {
    var groupedSubjects = [];
    subjects.forEach((s) => {
      if (groupedSubjects[s.year - 1] === undefined)
        groupedSubjects[s.year - 1] = [];
      groupedSubjects[s.year - 1].push(s);
    });
    return groupedSubjects;
  }
  changeMonths(numOfMonths) {
    if (!this.isOwnedUpgradeActive) {
      this.selectedChip = numOfMonths;
      this.totalPriceWithDiscount =
        this.calculateMonthlyFee(this.selectedSubjects, numOfMonths) *
        numOfMonths;
      this.monthlyFee = this.calculateMonthlyFee(
        this.selectedSubjects,
        numOfMonths
      );
      this.numOfMonths = numOfMonths;
      this.calculateTotal();
    }
  }
  pChanged(newP) {
    this.p = newP;
    this.totalPriceWithDiscount =
      this.calculateMonthlyFee(this.selectedSubjects, this.numOfMonths, newP) *
      this.numOfMonths;
    this.monthlyFee = this.calculateMonthlyFee(
      this.selectedSubjects,
      this.numOfMonths,
      newP
    );
    this.calculateTotal();
  }
  numOfMonthsChanged(numOfMonths) {
    this.totalPriceWithDiscount =
      this.calculateMonthlyFee(this.selectedSubjects, numOfMonths) *
      numOfMonths;
    this.monthlyFee = this.calculateMonthlyFee(
      this.selectedSubjects,
      numOfMonths
    );
    this.numOfMonths = numOfMonths;
    this.calculateTotal();
  }
  // calculateTotal() {
  //   this.totalPrice = this.selectedSubjects.reduce((sum, v) => sum + v.price, 0);
  //   this.totalPriceWithDiscount = this.calculateMonthlyFee(this.selectedSubjects, this.numOfMonths, this.p) * this.numOfMonths;
  //   this.monthlyFee = this.calculateMonthlyFee(this.selectedSubjects, this.numOfMonths, this.p);
  // }
  calculateTotal() {
    let isUpgradeActive = false;
    this.selectedSubjects = [];
    this.subjectsREG.forEach((g) => {
      g.forEach((s) => {
        if (s.selectedStudyboxes.length > 0) this.selectedSubjects.push(s);
      });
    });
    this.totalPrice = 0;
    this.selectedSubjects.forEach((s) => {
      if (
        this.user &&
        s.studyboxesShown.filter((sb) => sb.isUserOwned).length != 0
      )
        isUpgradeActive = true;
      this.totalPrice += s.selectedStudyboxes.reduce(
        (sum, v) => sum + v.studyboxPrice,
        0
      );
    });
    this.totalPriceWithDiscount =
      this.calculateMonthlyFee(
        this.selectedSubjects,
        this.numOfMonths,
        this.p
      ) * this.numOfMonths;
    this.monthlyFee = this.calculateMonthlyFee(
      this.selectedSubjects,
      this.numOfMonths,
      this.p
    );
    this.isOwnedUpgradeActive = isUpgradeActive;
  }
  // calculateMonthlyFee(subjects, numOfMonths = 5, p = 0.035) {
  //   var numOfSubjects = subjects.length;
  //   var yearMax = 1; //max godina
  //   var totalPriceREG = 0; //zbir cena svih izabranih paketa
  //   var totalPriceJIT = 0; //zbir cena svih izabranih paketa
  //   for (let subject of subjects) {
  //     if (subject.year > yearMax)
  //       yearMax = subject.year;
  //     if (subject.REG) totalPriceREG += subject.price;
  //     if (subject.JIT) totalPriceJIT += subject.price;
  //   }
  //   var f_year = 4 - yearMax;
  //   var f_nos = Math.max(0, 2 * numOfSubjects - 4);; //faktor popusta na osnovu broja paketa
  //   var f_nom = 0.4 * (5 - numOfMonths);
  //   var f_total = f_year + f_nos + f_nom;
  //   if (f_total * p > 0.25)
  //     f_total = 0.25 / p;
  //   var discount = (totalPriceREG + 0.4 * totalPriceJIT) * f_total * p;
  //   var monthlyFee;
  //   if (numOfSubjects == 1) { //jedan paket => nema popusta
  //     monthlyFee = (totalPriceREG + totalPriceJIT) / numOfMonths;
  //     return Math.trunc(monthlyFee);
  //   }
  //   monthlyFee = (totalPriceREG + totalPriceJIT - discount) / numOfMonths;
  //   monthlyFee = Math.floor(monthlyFee / 100) * 100; //zaokruziti na nizu okruglu stotinu
  //   return monthlyFee;
  // }
  calculateMonthlyFee(subjects, numOfMonths = 5, p = 0.035) {
    var numOfSubjects = subjects.length;
    var yearMax = 1; //max godina
    var totalPriceREG = 0; //zbir cena svih izabranih paketa
    var totalPriceJIT = 0; //zbir cena svih izabranih paketa
    for (let subject of subjects) {
      if (subject.year > yearMax) yearMax = subject.year;
      if (subject.REG)
        totalPriceREG += subject.selectedStudyboxes.reduce(
          (sum, v) => sum + v.studyboxPrice,
          0
        );
      if (subject.JIT)
        totalPriceJIT += subject.selectedStudyboxes.reduce(
          (sum, v) => sum + v.studyboxPrice,
          0
        );
    }
    var f_year = 4 - yearMax;
    var f_nos = Math.max(0, 2 * numOfSubjects - 4); //faktor popusta na osnovu broja paketa
    var f_nom = 0.4 * (5 - numOfMonths);
    var f_total = f_year + f_nos + f_nom;
    if (f_total * p > 0.25) f_total = 0.25 / p;
    var discount = (totalPriceREG + 0.4 * totalPriceJIT) * f_total * p;
    var monthlyFee;
    if (numOfSubjects == 1) {
      //jedan paket => nema popusta
      monthlyFee = (totalPriceREG + totalPriceJIT) / numOfMonths;
      return Math.trunc(monthlyFee);
    }
    monthlyFee = (totalPriceREG + totalPriceJIT - discount) / numOfMonths;
    monthlyFee = Math.floor(monthlyFee / 100) * 100; //zaokruziti na nizu okruglu stotinu
    return monthlyFee;
  }
  //int snizena_cena = br_rata * rata;// ovako se dobija konacna cena
  yearWord(year) {
    var returnWord = "";
    switch (year) {
      case 1:
        returnWord = "PRVA";
        break;
      case 2:
        returnWord = "DRUGA";
        break;
      case 3:
        returnWord = "TREĆA";
        break;
      case 4:
        returnWord = "ČETVRTA";
        break;
    }
    return returnWord;
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  async openDialog() {
    var currentUser = await this.auth.currentUser;
    // if (this.selectedSubjects.length > 0) {
    var dialog: any = OrderDialogComponent;
    if (currentUser != null) {
      (dialog = LoadingDialogComponent),
      {
        disableClose: true,
      };
    }
    if (this.selectedSubjects.length > 0) {
      var width = "40%";
      if (window.outerWidth < 992) width = "80%";
      const dialogRef = this.dialog.open(dialog, {
        width: width,
        height: "90%",
        data: {
          totalPrice: this.totalPrice,
          totalPriceWithDiscount: this.totalPriceWithDiscount,
          monthlyFee: this.monthlyFee,
          numOfMonths: this.numOfMonths,
          selectedSubjects: this.selectedSubjects,
        },
        panelClass: "submitDialogStyle",
      });
      if (currentUser != null) {
        this.func
          .httpsCallable("order-makeNewOrder")({
            numOfMonths: this.numOfMonths,
            subjects: this.selectedSubjects,
          })
          .subscribe(
            (data) => {
              this.zone.run(() => {
                console.log(data);
                dialogRef.close(200);
              });
            },
            (err) => {
              console.log(err);
            }
          );
      }
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 200) this.openSnackBar("Rezervacija uspešna!", "ok");
        else
          this.openSnackBar(
            "Rezervacija neuspešna. Molimo vas da probate ponovo",
            "ok"
          );
      });
    }
  }

  // async saveProposal(user, dialogRef) {
  //   console.log(user)
  //   try {
  //     var orderRef = await this.firestore.collection(`/users/${user.uid}/orders/`)
  //       .add({
  //         monthlyFee: this.monthlyFee,
  //         numOfMonths: this.numOfMonths,
  //         totalPrice: this.totalPrice,
  //         totalPriceWithDiscount: this.totalPriceWithDiscount,
  //         selectedSubjects: this.selectedSubjects,
  //         datetime: new Date()
  //       })
  //     this.func.httpsCallable('sendOrderRecievedEmail')({
  //       order_id: orderRef.id,
  //       uid: user.uid
  //     })
  //       .subscribe((res) => {
  //         this.zone.run(() => {
  //           console.log(res)
  //           dialogRef.close(200);
  //           this.changeDetectorRef.markForCheck();
  //         });
  //       })
  //   } catch (err) {
  //     console.log(err);
  //     dialogRef.close(400);
  //   }
  // }
}
